import { PatientExerciseAttributes } from '@/jsonapi/PatientExercise'
import { GetterNames } from './keys'
import { ExerciseState } from './types'
import { convertToExercisesByUserAndDate, sortExercisesByDate } from './converters'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'

export interface ExercisesByUserAndDate {
  [key: string]: {
    // patient id key
    [key: string]: FlatPatientExercise[] // date key
  }
}

export type FlatPatientExercise = FlatAPIData<PatientExerciseAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [GetterNames.exercises]: (state: ExerciseState): FlatPatientExercise[] => {
    return state.exercises.map(flattenJsonApiResponse)
  },
  [GetterNames.exercise]: (state: ExerciseState, getters): ((exerciseId: string) => FlatPatientExercise) => {
    return (exerciseId: string): FlatPatientExercise => {
      return getters[GetterNames.exercises].find(exercise => exercise.id === exerciseId)
    }
  },
  [GetterNames.exercisesForList]: (state: ExerciseState, getters): ExercisesByUserAndDate => {
    return convertToExercisesByUserAndDate(sortExercisesByDate(getters[GetterNames.exercises]))
  },
  [GetterNames.sortedExercises]: (state: ExerciseState, getters): FlatPatientExercise[] => {
    return sortExercisesByDate(getters[GetterNames.exercises])
  },
}
